import { InputFieldBase } from '../Fields/types'

export const getUpdatedFields = (fields: InputFieldBase[]): InputFieldBase[] => {
  const updatedFields: InputFieldBase[] = []

  fields.forEach(field => {
    updatedFields.push(field)

    if (field.hasConfirmation) {
      const confirmationField: InputFieldBase = {
        fieldType: field.fieldType,
        label: 'Gentag forrige felt',
        name: 'confirmation-' + field.name,
        required: true,
      }

      // Insert the confirmation field after the original field
      updatedFields.push(confirmationField)
    }
  })

  return updatedFields
}
